var map = {
	"./avalanche/factories-latest.json": 7945,
	"./goerli/factories-latest.json": 68530,
	"./kovan/factories-latest.json": 64763,
	"./localhost/factories-latest.json": 43065,
	"./mainnet/factories-latest.json": 35158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48543;